import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import React from 'react'
import {
  Route,
  Switch,
  withRouter,
  Redirect,
} from 'react-router-dom'
import { Helmet } from 'react-helmet'

import settings from 'settings'

import PrivateRoute from './PrivateRoute'
import SeoRoute from './SeoRoute'
// Containers
import All from '../containers/All'
import Auth from '../containers/Auth'
import ByVulnerability from '../containers/ByVulnerability'
import Challenges from '../containers/Challenges'
import Invite from '../containers/Invite'
import Leaderboard from '../containers/Leaderboard'
import LessonDetail from '../containers/LessonDetail'
import MyPlan from '../containers/MyPlan'
import NotFound from '../containers/NotFound'
import Profile from '../containers/Profile'

import QuizDetail from '../containers/Quiz/QuizDetail'
import QuizInvite from '../containers/Quiz/QuizInvite'
import QuizReset from '../containers/Quiz/QuizReset'
import QuizResults from '../containers/Quiz/QuizResults'
import QuizStep from '../containers/Quiz/QuizStep'
import QuizSurvey from '../containers/Quiz/QuizSurvey'
import QuizTakeTheTest from '../containers/Quiz/QuizTakeTheTest'
import QuizTour from '../containers/Quiz/QuizTour'
import QuizOverview from '../containers/Quiz/QuizOverview'

import Upgrade from '../containers/Upgrade'
import Login from '../containers/Login'
import Register from '../containers/Register'
import ForgotPassword from '../containers/ForgotPassword'
import ResetPassword from '../containers/ResetPassword'
import VerifyEmail from '../containers/VerifyEmail'

// organizations
import Organizations from '../containers/Organizations'

// organizations - dashboard
import OrganizationDashboard from '../containers/Organizations/Dashboard'

// organizations - users
import OrganizationsUsers from '../containers/Organizations/Users'

// organizations - teams
import OrganizationsTeams from '../containers/Organizations/Teams/List'
import OrganizationsTeamsAdd from '../containers/Organizations/Teams/Add'
import OrganizationsTeamsDetail from '../containers/Organizations/Teams/Detail'
import OrganizationsTeamsEdit from '../containers/Organizations/Teams/Edit'
import OrganizationsTeamsUsersEdit from '../containers/Organizations/Teams/UsersEdit'

// organizations - plans
import OrganizationsPlans from '../containers/Organizations/Plans/List'
import OrganizationsPlansDetails from '../containers/Organizations/Plans/Details'
import OrganizationsPlansAdd from '../containers/Organizations/Plans/Add'
import OrganizationsPlansEdit from '../containers/Organizations/Plans/Edit'
import OrganizationsPlansPhaseAdd from '../containers/Organizations/Plans/PhaseAdd'
import OrganizationsPlansPhaseEdit from '../containers/Organizations/Plans/PhaseEdit'

// organizations - reports
import CustomReport from '../containers/Organizations/Reports/CustomReport'
import DownloadReport from '../containers/Organizations/Reports/DownloadReport'
import OrganizationsReports from '../containers/Organizations/Reports'
import CompletedReports from '../containers/Organizations/Reports/CompletedReports'
import IncompletedReports from '../containers/Organizations/Reports/IncompletedReports'
import MasteryReport from '../containers/Organizations/Reports/MasteryReport'
import ChallengeReport from '../containers/Organizations/Reports/ChallengeReport'

// organizations - settings
import OrganizationsSettings from '../containers/Organizations/Settings'

// TODO: Combine these into a single component
import ContentDetail from '../containers/ContentDetail'
import DemoEn from '../containers/Demo/en'
import DemoEs from '../containers/Demo/es'
import DemoPt from '../containers/Demo/pt'
import SamyWorm from '../containers/SamyWorm'
import SamyWormNew from '../containers/SamyWormNew'
import SQLInjection from '../containers/SQLInjection'


const propTypes = {
  authenticationStatus: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
}

const Routes = ({
  authenticationStatus,
  organizationsHash,
  hasLoadedOrganizations,
}) => {
  if (authenticationStatus === 'PENDING' || ((authenticationStatus === 'LOGGED_IN') && !hasLoadedOrganizations)) {
    return <div />
  }
  return (
    <>
      <Helmet>
        <meta name="description" content="Interactive Cybersecurity Training. HackEDU offers comprehensive online Secure Development Training for your developers, engineers, and IT personnel to assist your organization in laying a foundation of security and application vulnerability prevention, assessment, and remediation." />
        <meta name="keywords" content="cybersecurity, security, secure coding, secure coding training, secure development, secure development training, PCI compliance, training, platform, hacker, school, online, tools" />
        <meta property="og:title" content="Interactive Cybersecurity Training | HackEDU" />
        <meta property="og:description" content="Interactive Cybersecurity Training. HackEDU offers comprehensive online Secure Development Training for your developers, engineers, and IT personnel to assist your organization in laying a foundation of security and application vulnerability prevention, assessment, and remediation." />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="HackEDU" />
        <meta property="og:url" content="https://www.hackedu.io/" />

        <title>Interactive Cybersecurity Training | HackEDU</title>
      </Helmet>

      <Switch>
        {/* Seo Routes */}

        {/* Redirect needs to be before actual Route that is gonna be used */}
        <Redirect
          from="/capital-one-breach"
          to="/lesson/4f059a0c-ebb5-11e9-852d-0a7816aaa30a"
        />
        <Redirect
          from="/hacktivity/85624"
          to="/hacktivity/679f0662-4149-4585-8542-42dd527e0bdb"
        />
        <Redirect
          from="/hacktivity/highly-wormable-clickjacking-in-twitter-player-card"
          to="/hacktivity/679f0662-4149-4585-8542-42dd527e0bdb"
        />
        <Redirect
          from="/hacktivity/312543"
          to="/hacktivity/ef152bdd-af90-4e68-aac2-5f9f3a7c355f"
        />
        <Redirect
          from="/hacktivity/xxe-in-site-audit-function"
          to="/hacktivity/ef152bdd-af90-4e68-aac2-5f9f3a7c355f"
        />
        <Redirect
          from="/hacktivity/rce-by-command-line-injection-to-gm-convert"
          to="/hacktivity/5f8e247b-98bc-4b7a-aa97-472dcc34a6f8"
        />
        <Redirect
          from="/hacktivity/drivegrab-sql-injection"
          to="/hacktivity/6f2d6933-e632-4e01-8add-2d161bb6b059"
        />
        <Redirect
          from="/hacktivity/stealing-hackerone-form-data-using-marketo-xss"
          to="/hacktivity/46e75af5-9692-4380-845c-ac570c755d7c"
        />
        <Redirect
          from="/vulnerability/39af3508-4e77-482d-9e45-af19ec21524d"
          to="/vulnerabilities/39af3508-4e77-482d-9e45-af19ec21524d"
        />
        <Redirect
          from="/vulnerability/0a61ce9a-2a6a-4235-ace4-cc224ec81079"
          to="/vulnerabilities/0a61ce9a-2a6a-4235-ace4-cc224ec81079"
        />
        <Redirect
          from="/vulnerability/34fd4f1c-f4ba-416f-99ab-f17d426a7f29"
          to="/vulnerabilities/34fd4f1c-f4ba-416f-99ab-f17d426a7f29"
        />
        <SeoRoute
          exact
          path="/demo"
          component={DemoEn}
          title="SQL Injection Lesson | Hands-On Training"
          description="SQL injection (SQLi) is where an attacker can inject SQL commands into a SQL statement. Try this FREE hands-on, interactive lesson. Languages include Java, .NET, C#, Python, PHP, Ruby, Node, Javascript, Golang"
          keywords="SQL injection, SQLi, vulnerabilities, public vulnerabilities, vulnerabilty, Secure Coding Training, Secure Development, Secure Development Training, secure coding, Java, .NET, C#, Python, PHP, Ruby, Node, Javascript, Golang"
        />
        <SeoRoute
          exact
          path="/es/demo"
          component={DemoEs}
          title="Inyección SQL Lección | La Pormación Práctica"
          description="Una inyección SQL (SQLi) es cuando un atacante puede inyectar comandos SQL en una consulta SQL. Pruebe esta lección interactiva, práctica y GRATUITA. Los idiomas incluyen Java, .NET, C#, Python, PHP, Ruby, Node, Javascript, Golang"
          keywords="Inyección SQL Lección, Software Seguro, SQL injection, SQLi, vulnerabilities, public vulnerabilities, vulnerabilty, Secure Coding Training, Secure Development, Secure Development Training, secure coding, Java, .NET, C#, Python, PHP, Ruby, Node, Javascript, Golang"
        />
        <SeoRoute
          exact
          path="/pt/demo"
          component={DemoPt}
          title="Injeção de SQL | A Porção Prática"
          description="Uma injeção de SQL (SQLi) é quando um invasor pode injetar comandos SQL em uma consulta SQL. Experimente esta lição interativa, prática e gratuita. Os idiomas incluem Java, .NET, C #, Python, PHP, Ruby, Nó, Javascript, Golang"
          keywords="Injeção de SQL, Software seguro, SQL injection, Treinamento de codificação segura, SQLi, vulnerabilities, public vulnerabilities, vulnerabilty, Secure Coding Training, Secure Development, Secure Development Training, secure coding, Java, .NET, C#, Python, PHP, Ruby, Node, Javascript, Golang"
        />
        <SeoRoute
          exact
          path="/samy-worm"
          component={SamyWorm}
          title="MySpace 'Samy' Worm Hands-On Lesson"
          description="The Samy Worm helped change the public perception of Cross-Site Scripting vulnerabilities and managed to raise awareness of the importance of web application security. If a harmless worm managed to cause massive problems for the largest platform at that time, imagine what might have happened if someone had exploited the vulnerability for malicious purposes. We will now replicate the exploitation of the vulnerability in a safe environment."
          keywords="Samy Worm, MySpace Worm, XSS, Cross-Site Scripting, vulnerabilities, public vulnerabilities, vulnerabilty, Secure Coding Training, Secure Development, Secure Development Training, secure coding"
        />


        {/* Auth */}
        <Route exact path="/login/allegiant" render={() => { window.location = `${settings.urls.app}/login?domain=allegiantair.com`; return <div /> }} />
        <Route exact path="/login" component={Login} />
        <PrivateRoute exact path="/" component={MyPlan} />
        <Route exact path="/auth" component={Auth} />
        <Route exact path="/auth/:client_id" component={Auth} />
        <Route exact path="/verify/email/:code" component={VerifyEmail} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/register" component={Register} />
        <Route exact path="/forgot-password" component={ForgotPassword} />
        <Route exact path="/reset-password" component={ResetPassword} />

        {/* Public Training Routes */}
        <Route exact path="/demo" component={DemoEn} />
        <Route exact path="/sql-injection" component={SQLInjection} />
        <Route exact path="/samy-worm-old" component={SamyWorm} />
        <Route exact path="/samy-worm" component={SamyWormNew} />


        {/* Private Training Routes */}
        <PrivateRoute exact path="/all" component={All} />
        <PrivateRoute exact path="/by-vulnerability" component={ByVulnerability} />
        <PrivateRoute exact path="/challenges" component={Challenges} />
        <PrivateRoute path="/profile" component={Profile} />
        <PrivateRoute path="/leaderboard" component={Leaderboard} />
        <PrivateRoute path="/lesson/:id" component={LessonDetail} />
        <PrivateRoute path="/challenge/:id" component={ContentDetail} />
        <PrivateRoute path="/practice/:id" component={ContentDetail} />
        <PrivateRoute path="/lesson/:id" component={ContentDetail} />
        <PrivateRoute path="/topic/:id" component={ContentDetail} />
        <PrivateRoute
          path="/upgrade"
          component={Upgrade}
        />

        {/* Organizations */}
        <Route exact path="/invite" component={Invite} />
        <Route exact path="/invite/:id" component={Invite} />

        {/* Admin Dashboard */}
        <PrivateRoute exact path="/admin" component={Organizations} />
        <PrivateRoute exact path="/admin/:organization_uuid/dashboard" component={OrganizationDashboard} />
        {/* Admin Users */}
        <PrivateRoute exact path="/admin/:organization_uuid/users" component={OrganizationsUsers} />
        <PrivateRoute exact path="/admin/:organization_uuid/users/:hacker_uuid/:tab" component={OrganizationsUsers} />

        {/* Admin Teams */}
        <PrivateRoute exact path="/admin/:organization_uuid/teams" component={OrganizationsTeams} />
        <PrivateRoute exact path="/admin/:organization_uuid/teams/add" component={OrganizationsTeamsAdd} />
        <PrivateRoute exact path="/admin/:organization_uuid/teams/:team_uuid/users" component={OrganizationsTeamsDetail} />
        <PrivateRoute exact path="/admin/:organization_uuid/teams/:team_uuid/users/:hacker_uuid/:tab" component={OrganizationsTeamsDetail} />
        <PrivateRoute exact path="/admin/:organization_uuid/teams/:team_uuid/plans" component={OrganizationsTeamsDetail} />
        <PrivateRoute exact path="/admin/:organization_uuid/teams/:team_uuid/settings" component={OrganizationsTeamsDetail} />

        <PrivateRoute exact path="/admin/:organization_uuid/teams/:team_uuid/plan/:plan_uuid/phase/:phase_uuid/edit" component={OrganizationsTeamsDetail} />

        <PrivateRoute exact path="/admin/:organization_uuid/teams/:team_uuid/edit" component={OrganizationsTeamsEdit} />
        <PrivateRoute exact path="/admin/:organization_uuid/teams/:team_uuid/users" component={OrganizationsTeamsUsersEdit} />


        {/* Admin Plans */}
        <PrivateRoute exact path="/admin/:organization_uuid/plans" component={OrganizationsPlans} />
        <PrivateRoute exact path="/admin/:organization_uuid/plans/add" component={OrganizationsPlansAdd} />
        <PrivateRoute exact path="/admin/:organization_uuid/plans/add/team" component={OrganizationsPlansAdd} />
        <PrivateRoute exact path="/admin/:organization_uuid/plans/:plan_uuid" component={OrganizationsPlansDetails} />
        <PrivateRoute exact path="/admin/:organization_uuid/plans/:plan_uuid/edit" component={OrganizationsPlansEdit} />
        <PrivateRoute exact path="/admin/:organization_uuid/plans/:plan_uuid/phase/add" component={OrganizationsPlansPhaseAdd} />
        <PrivateRoute exact path="/admin/:organization_uuid/plans/:plan_uuid/phase/:phase_uuid/edit" component={OrganizationsPlansPhaseEdit} />

        {/* Admin Reports */}
        <PrivateRoute exact path="/admin/:organization_uuid/reports" component={OrganizationsReports} />
        <PrivateRoute exact path="/admin/:organization_uuid/reports/custom" component={CustomReport} />
        <PrivateRoute exact path="/admin/:organization_uuid/reports/completed" component={CompletedReports} />
        <PrivateRoute exact path="/admin/:organization_uuid/reports/incompleted" component={IncompletedReports} />
        <PrivateRoute exact path="/admin/:organization_uuid/reports/challenges" component={ChallengeReport} />
        <PrivateRoute exact path="/admin/:organization_uuid/reports/mastery" component={MasteryReport} />
        <PrivateRoute exact path="/admin/:organization_uuid/reports/download" component={DownloadReport} />

        {/* Team Reports */}
        <PrivateRoute exact path="/admin/:organization_uuid/teams/:team_uuid/reports/custom" component={CustomReport} />
        <PrivateRoute exact path="/admin/:organization_uuid/teams/:team_uuid/reports/completed" component={CompletedReports} />
        <PrivateRoute exact path="/admin/:organization_uuid/teams/:team_uuid/reports/incompleted" component={IncompletedReports} />
        <PrivateRoute exact path="/admin/:organization_uuid/teams/:team_uuid/reports/challenges" component={ChallengeReport} />
        <PrivateRoute exact path="/admin/:organization_uuid/teams/:team_uuid/reports/mastery" component={MasteryReport} />
        <PrivateRoute exact path="/admin/:organization_uuid/teams/:team_uuid/reports/download" component={DownloadReport} />

        <PrivateRoute exact path="/admin/:organization_uuid/settings" component={OrganizationsSettings} />

        {/* Secure Coding IQ - Quizes */}
        <PrivateRoute exact path="/quiz" component={QuizOverview} />
        <Route exact path="/quiz/reset" component={QuizReset} />
        <Route exact path="/quiz/take-the-test" component={QuizTakeTheTest} />
        <Route exact path="/quiz/:id" component={QuizDetail} />
        <Route exact path="/quiz/:id/invite" component={QuizInvite} />
        <Route exact path="/quiz/:id/steps" component={QuizStep} />
        <Route exact path="/quiz/:id/survey" component={QuizSurvey} />
        <Route exact path="/quiz/:id/tour" component={QuizTour} />
        <Route exact path="/quiz/:id/results" component={QuizResults} />

        {/* Global for both authenticated & unauthenticated users */}
        <Route exact path="/404" component={NotFound} />
        {/* spanish routes */}
        <Route exact path="/es/demo" component={DemoEs} />
        <Route exact path="/demo/es" component={DemoEs} />
        <Route exact path="/es/sql-injection" component={DemoEs} />
        {/* portuguese routes */}
        <Route exact path="/pt/demo" component={DemoPt} />
        <Route exact path="/demo/pt" component={DemoPt} />
        {/* Route Redirects */}
        <Route
          exact
          path="/admin/:organization_uuid"
          render={({ match }) => {
            const { role } = organizationsHash[match.params.organization_uuid]
            let redirectTo = ''
            if (role === 'admin') {
              redirectTo = 'users'
            }
            if (organizationsHash[match.params.organization_uuid].team_admin_uuids.length > 0) {
              redirectTo = 'teams'
            }
            if (redirectTo === '') return <Redirect to="/404" />
            return <Redirect to={`/admin/${match.params.organization_uuid}/${redirectTo}`} />
          }}
        />

        {/* Redirects */}
        {/* This routes are based on redirects so need to be after the redirects */}
        <PrivateRoute path="/vulnerability/:id" component={ContentDetail} />
        <PrivateRoute exact path="/hacktivity/:id" component={ContentDetail} />
        <PrivateRoute exact path="/vulnerabilities/:id" component={ContentDetail} />
        <Route component={NotFound} />

      </Switch>
    </>
  )
}

Routes.propTypes = propTypes

function mapStateToProps(state) {
  return {
    authenticationStatus: state.auth.authenticationStatus,
    isAuthenticated: state.auth.authenticationStatus === 'LOGGED_IN',
    organizationsHash: state.hacker.organizationsHash,
    hasLoadedOrganizations: state.hacker.hasLoadedOrganizations,
  }
}
export default withRouter(connect(mapStateToProps)(Routes))
